"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var customDatalayerInterface_1 = require("../../../../../../common/utilities/customDatalayerInterface");
var dxpProducts_1 = require("../../../../../../common/constants/dxpProducts");
var dxpDataLayerHandler_1 = require("../../../common/utils/dxpDataLayerHandler");
var JourneyStepsRoutes_1 = require("../../../checkout4/enum/JourneyStepsRoutes");
var dxpDigitalDataAssignment_1 = require("../../../../../../common/utilities/dxpDigitalDataAssignment");
exports.useEnquiryDataLayer = function (deal) {
    var handleDataLayerChange = function (_a) {
        var formSchema = _a.formSchema, formData = _a.formData;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        var dealerSelect = null;
        var dealerIndex = null;
        var formDataSchema = formData;
        var formDataData = formData;
        var getDealerSelect = function (property) {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = formSchema) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b[property]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.dealerSelect;
        };
        if ((_c = (_b = formDataSchema) === null || _b === void 0 ? void 0 : _b.dealerConsultant) === null || _c === void 0 ? void 0 : _c.dealerSelect) {
            dealerSelect = getDealerSelect('dealerConsultant');
            dealerIndex = (_e = (_d = formDataSchema) === null || _d === void 0 ? void 0 : _d.dealerConsultant) === null || _e === void 0 ? void 0 : _e.dealerSelect;
        }
        else if ((_g = (_f = formDataSchema) === null || _f === void 0 ? void 0 : _f.appointment) === null || _g === void 0 ? void 0 : _g.dealerSelect) {
            dealerSelect = getDealerSelect('appointment');
            dealerIndex = (_j = (_h = formDataSchema) === null || _h === void 0 ? void 0 : _h.appointment) === null || _j === void 0 ? void 0 : _j.dealerSelect;
        }
        else if ((_l = (_k = formDataSchema) === null || _k === void 0 ? void 0 : _k.cityDealer) === null || _l === void 0 ? void 0 : _l.dealerSelect) {
            dealerSelect = getDealerSelect('cityDealer');
            dealerIndex = (_o = (_m = formDataSchema) === null || _m === void 0 ? void 0 : _m.cityDealer) === null || _o === void 0 ? void 0 : _o.dealerSelect;
        }
        else if ((_p = formDataData) === null || _p === void 0 ? void 0 : _p.dealerSelect) {
            dealerSelect = (_q = formSchema) === null || _q === void 0 ? void 0 : _q.properties.dealerSelect;
            dealerIndex = (_r = formDataData) === null || _r === void 0 ? void 0 : _r.dealerSelect;
        }
        else if ((_s = formDataSchema) === null || _s === void 0 ? void 0 : _s.cityDistrictDealer) {
            dealerSelect = getDealerSelect('cityDistrictDealer');
            dealerIndex = (_u = (_t = formDataSchema) === null || _t === void 0 ? void 0 : _t.cityDistrictDealer) === null || _u === void 0 ? void 0 : _u.dealerSelect;
        }
        if (dealerSelect && dealerIndex) {
            updateDealerSelectDataLayer({ dealerSelect: dealerSelect, dealerIndex: dealerIndex });
        }
    };
    var updateDealerSelectDataLayer = function (_a) {
        var dealerSelect = _a.dealerSelect, dealerIndex = _a.dealerIndex;
        var _b, _c;
        var dealerEnum = (_b = dealerSelect) === null || _b === void 0 ? void 0 : _b.enum.findIndex(function (e) { return e === dealerIndex; });
        var dealerName = (_c = dealerSelect) === null || _c === void 0 ? void 0 : _c.enumNames[dealerEnum];
        var dataLayer = __assign(__assign({ event: customDatalayerInterface_1.DxpDataLayerEvent.CONFIGURATOR, eventName: customDatalayerInterface_1.DxpDataLayerEventNames.CNF_DEALERS_CLICKED, pageTitle: document.title, DXPProduct: dxpProducts_1.default.checkout, dealerPreference: dealerName }, dxpDataLayerHandler_1.formatDataLayerDeal(deal)), { nextSteps: dxpDataLayerHandler_1.getSaveEnquiryFormNextSteps(), stepName: JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER.replace('/', '') });
        dxpDigitalDataAssignment_1.default(dataLayer);
    };
    return { handleDataLayerChange: handleDataLayerChange, updateDealerSelectDataLayer: updateDealerSelectDataLayer };
};
